const Arrow = ({ size, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.343 8h11.314m0 0-4.984 4.984M13.657 8 8.673 3.016"
    ></path>
  </svg>
);
const Facebook = ({ size, fill }) => (
  <svg
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7619 39V27.1595H30.7564L31.3502 22.5235H26.7619V19.5706C26.7619 18.2328 27.1346 17.3169 29.0546 17.3169H31.4874V13.1837C30.3037 13.0569 29.1139 12.9956 27.9234 13.0002C24.3927 13.0002 21.9685 15.1557 21.9685 19.1126V22.5149H18V27.1508H21.9772V39H26.7619Z"
      fill="white"
    />
  </svg>
);
const LinkedIn = ({ size, fill }) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6095 16.219C14.2206 16.219 15.5267 14.913 15.5267 13.3019C15.5267 11.6908 14.2206 10.3848 12.6095 10.3848C10.9984 10.3848 9.69238 11.6908 9.69238 13.3019C9.69238 14.913 10.9984 16.219 12.6095 16.219Z"
      fill={fill || "white"}
    />
    <path
      d="M18.2821 18.4298V34.6139H23.3071V26.6105C23.3071 24.4987 23.7044 22.4535 26.3229 22.4535C28.9054 22.4535 28.9373 24.868 28.9373 26.7438V34.6153H33.965V25.7399C33.965 21.3802 33.0264 18.0298 27.9308 18.0298C25.4842 18.0298 23.8444 19.3724 23.1737 20.6429H23.1057V18.4298H18.2821ZM10.0933 18.4298H15.1263V34.6139H10.0933V18.4298Z"
      fill={fill || "white"}
    />
  </svg>
);
const Clutch = ({ size, fill }) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.8904 27.4452C26.6541 28.4342 24.9233 29.176 23.1925 29.176C19.2364 29.176 16.5166 26.2089 16.5166 22.2529C16.5166 18.2969 19.2364 15.5771 23.1925 15.5771C24.9233 15.5771 26.6541 16.0716 27.8904 17.3078L28.6321 18.0496L32.5882 14.3408L31.5992 13.599C29.3739 11.621 26.4068 10.3848 23.1925 10.3848C16.2693 10.3848 11.0769 15.5771 11.0769 22.5002C11.0769 29.4232 16.2693 34.6155 23.1925 34.6155C26.4068 34.6155 29.3739 33.3793 31.5992 31.4013L32.5882 30.6595L28.6321 26.7034L27.8904 27.4452Z"
      fill="white"
    />
    <path
      d="M22.9454 26.457C25.1303 26.457 26.9015 24.6858 26.9015 22.501C26.9015 20.3161 25.1303 18.5449 22.9454 18.5449C20.7605 18.5449 18.9893 20.3161 18.9893 22.501C18.9893 24.6858 20.7605 26.457 22.9454 26.457Z"
      fill="white"
    />
  </svg>
);
const Instagram = ({ size, fill }) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.4717 16.2583C20.8241 16.2583 19.244 16.9128 18.079 18.0778C16.914 19.2428 16.2595 20.8229 16.2595 22.4705C16.2595 24.1181 16.914 25.6982 18.079 26.8632C19.244 28.0282 20.8241 28.6827 22.4717 28.6827C24.1193 28.6827 25.6993 28.0282 26.8644 26.8632C28.0294 25.6982 28.6839 24.1181 28.6839 22.4705C28.6839 20.8229 28.0294 19.2428 26.8644 18.0778C25.6993 16.9128 24.1193 16.2583 22.4717 16.2583ZM22.4717 26.5049C21.4013 26.5049 20.3748 26.0797 19.618 25.3229C18.8611 24.566 18.4359 23.5395 18.4359 22.4691C18.4359 21.3988 18.8611 20.3723 19.618 19.6154C20.3748 18.8586 21.4013 18.4334 22.4717 18.4334C23.542 18.4334 24.5685 18.8586 25.3254 19.6154C26.0822 20.3723 26.5074 21.3988 26.5074 22.4691C26.5074 23.5395 26.0822 24.566 25.3254 25.3229C24.5685 26.0797 23.542 26.5049 22.4717 26.5049Z"
      fill="white"
    />
    <path
      d="M28.9297 17.4781C29.7295 17.4781 30.3779 16.8297 30.3779 16.0298C30.3779 15.2299 29.7295 14.5815 28.9297 14.5815C28.1298 14.5815 27.4814 15.2299 27.4814 16.0298C27.4814 16.8297 28.1298 17.4781 28.9297 17.4781Z"
      fill="white"
    />
    <path
      d="M33.9367 14.5576C33.6257 13.7544 33.1505 13.0251 32.5413 12.4162C31.9322 11.8073 31.2027 11.3323 30.3994 11.0216C29.4594 10.6687 28.4664 10.4779 27.4626 10.4573C26.1688 10.4009 25.7591 10.3848 22.4784 10.3848C19.1976 10.3848 18.7771 10.3848 17.4941 10.4573C16.4911 10.4769 15.4988 10.6677 14.56 11.0216C13.7565 11.3319 13.0268 11.8068 12.4176 12.4157C11.8085 13.0247 11.3333 13.7542 11.0227 14.5576C10.6697 15.4975 10.4794 16.4906 10.4598 17.4944C10.402 18.7868 10.3845 19.1966 10.3845 22.4787C10.3845 25.7594 10.3845 26.1772 10.4598 27.4629C10.4799 28.4678 10.6693 29.4593 11.0227 30.4011C11.3342 31.2042 11.8098 31.9334 12.4191 32.5423C13.0284 33.1511 13.758 33.6262 14.5613 33.9371C15.4983 34.3041 16.4911 34.5086 17.4968 34.5416C18.7906 34.5981 19.2003 34.6155 22.481 34.6155C25.7618 34.6155 26.1823 34.6155 27.4653 34.5416C28.469 34.5212 29.462 34.3309 30.4021 33.9787C31.2052 33.6673 31.9345 33.1919 32.5435 32.5828C33.1526 31.9738 33.628 31.2444 33.9394 30.4414C34.2928 29.501 34.4822 28.5095 34.5023 27.5046C34.5601 26.2122 34.5776 25.8024 34.5776 22.5203C34.5776 19.2382 34.5776 18.8217 34.5023 17.536C34.4867 16.5181 34.2954 15.5104 33.9367 14.5576ZM32.3004 27.3635C32.2917 28.1377 32.1504 28.9048 31.8826 29.6313C31.6808 30.1537 31.372 30.6281 30.9758 31.024C30.5797 31.4199 30.1051 31.7285 29.5826 31.9299C28.8641 32.1966 28.1053 32.3379 27.339 32.3478C26.0627 32.4069 25.7027 32.4217 22.43 32.4217C19.1546 32.4217 18.8201 32.4217 17.5196 32.3478C16.7538 32.3384 15.9953 32.197 15.2774 31.9299C14.753 31.7297 14.2765 31.4217 13.8787 31.0257C13.4809 30.6298 13.1706 30.1547 12.968 29.6313C12.7039 28.9126 12.5627 28.1546 12.5502 27.389C12.4924 26.1127 12.479 25.7527 12.479 22.48C12.479 19.206 12.479 18.8714 12.5502 17.5696C12.5589 16.7958 12.7002 16.0292 12.968 15.3032C13.3778 14.2432 14.2174 13.4089 15.2774 13.0032C15.9956 12.7374 16.7539 12.5961 17.5196 12.5854C18.7973 12.5276 19.156 12.5115 22.43 12.5115C25.704 12.5115 26.0399 12.5115 27.339 12.5854C28.1053 12.5946 28.8643 12.7359 29.5826 13.0032C30.1051 13.2051 30.5796 13.514 30.9757 13.9101C31.3718 14.3062 31.6807 14.7807 31.8826 15.3032C32.1467 16.0219 32.2879 16.7799 32.3004 17.5454C32.3582 18.8231 32.3729 19.1818 32.3729 22.4558C32.3729 25.7285 32.373 26.0805 32.3152 27.3648H32.3004V27.3635Z"
      fill="white"
    />
  </svg>
);
const WhatsApp = ({ size, fill }) => (
  <svg
    width={size || 45}
    height={size || 45}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 26L1.89091 19.0604C0.393624 16.3572 -0.078491 13.2047 0.56119 10.1815C1.20087 7.15825 2.90942 4.46717 5.37329 2.60213C7.83716 0.737099 10.891 -0.176748 13.9744 0.0283175C17.0577 0.233383 19.9637 1.5436 22.1589 3.7185C24.354 5.8934 25.6912 8.78704 25.9249 11.8683C26.1586 14.9496 25.2731 18.0119 23.431 20.4929C21.5889 22.974 18.9138 24.7075 15.8967 25.3752C12.8795 26.043 9.72281 25.6001 7.00585 24.128L0 26ZM7.31781 21.528L7.75274 21.7927C9.93379 23.0931 12.5152 23.5505 15.0102 23.0788C17.5053 22.6072 19.7416 21.239 21.2975 19.2322C22.8534 17.2254 23.6213 14.7188 23.4565 12.1849C23.2917 9.651 22.2056 7.26493 20.4029 5.4766C18.6002 3.68826 16.2056 2.62122 13.6704 2.47668C11.1353 2.33214 8.63489 3.12009 6.64063 4.69194C4.64637 6.2638 3.29605 8.51095 2.84433 11.0097C2.3926 13.5085 2.87065 16.0861 4.18836 18.2567L4.45311 18.7011L3.432 22.568L7.31781 21.528Z"
      fill={fill}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.8268 14.6537C17.572 14.4509 17.2748 14.3082 16.9573 14.2362C16.6397 14.1642 16.31 14.1647 15.9926 14.2377C15.5105 14.4363 15.2079 15.1832 14.9053 15.5614C14.8389 15.652 14.7412 15.7147 14.6312 15.7374C14.5212 15.7601 14.4066 15.7412 14.3097 15.6843C12.568 15.0049 11.1082 13.7551 10.1686 12.1388C10.0868 12.0371 10.0471 11.9079 10.0577 11.7777C10.0683 11.6476 10.1282 11.5265 10.2253 11.4392C10.5778 11.1042 10.8383 10.6842 10.9817 10.2196C11.0103 9.71463 10.8921 9.21222 10.6413 8.77302C10.4487 8.14493 10.0775 7.58647 9.57297 7.16575C9.31421 7.04507 9.02569 7.00313 8.74327 7.04516C8.46086 7.08718 8.19703 7.21131 7.98461 7.40211C7.62014 7.71755 7.33081 8.11048 7.13778 8.55216C6.94475 8.99384 6.85292 9.47309 6.86899 9.95483C6.8704 10.2291 6.90531 10.5021 6.97297 10.7679C7.14228 11.4014 7.40348 12.0066 7.74825 12.5643C7.9961 12.9889 8.26754 13.3992 8.56133 13.7934C9.51392 15.1045 10.7115 16.2186 12.0879 17.0741C12.7778 17.5018 13.5135 17.8506 14.2813 18.1141C15.0829 18.4788 15.9684 18.6193 16.8435 18.5206C17.3414 18.4429 17.8127 18.2446 18.2164 17.943C18.6201 17.6415 18.944 17.2458 19.1599 16.7905C19.2832 16.5148 19.3195 16.208 19.2639 15.9112C19.1315 15.3061 18.3184 14.9468 17.8268 14.6537Z"
      fill={fill}
    />
  </svg>
);
const X = ({ size, fill }) => (
  <svg
    width={size || 45}
    height={size || 45}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49512 0.173828L7.54688 0.25L13.2139 8.45703L20.2822 0.235352L20.335 0.173828H22.7266L22.4785 0.461914L14.2588 10.0195L23.1855 23.0654L23.3721 23.3389H16.3047L16.2529 23.2627L10.2949 14.5918L2.82227 23.2773L2.76953 23.3389H0.378906L0.625977 23.0508L9.23145 13.0195L0.614258 0.447266L0.426758 0.173828H7.49512ZM10.5977 11.7812L11.4873 13.0469L11.5713 13.167L11.5508 13.1865L17.4248 21.5986H20.0234L12.8623 11.3057L11.9834 10.04V10.0391L6.36621 2.01074H3.76758L10.5977 11.7812Z"
      fill={fill}
      stroke={fill}
      stroke-width="0.348661"
    />
  </svg>
);
const LinkIcon = ({ size, fill }) => (
  <svg
    width={size || 45}
    height={size || 45}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.875 25C4.97685 25 3.35648 24.3287 2.01389 22.9861C0.671296 21.6435 0 20.0231 0 18.125C0 17.1991 0.173611 16.3194 0.520833 15.4861C0.868056 14.6528 1.36574 13.912 2.01389 13.2639L5.65972 9.61806C5.9375 9.34028 6.26736 9.20139 6.64931 9.20139C7.03125 9.20139 7.36111 9.34028 7.63889 9.61806C7.91667 9.89583 8.05556 10.2199 8.05556 10.5903C8.05556 10.9606 7.91667 11.2847 7.63889 11.5625L3.95833 15.2431C3.56482 15.6366 3.26968 16.0822 3.07292 16.5799C2.87616 17.0775 2.77778 17.5926 2.77778 18.125C2.77778 19.2593 3.17708 20.2257 3.97569 21.0243C4.77431 21.8229 5.74074 22.2222 6.875 22.2222C7.40741 22.2222 7.92824 22.1238 8.4375 21.9271C8.94676 21.7303 9.39815 21.4352 9.79167 21.0417L13.4375 17.3611C13.7153 17.1065 14.0394 16.9792 14.4097 16.9792C14.7801 16.9792 15.1042 17.1181 15.3819 17.3958C15.6597 17.6736 15.7986 17.9977 15.7986 18.3681C15.7986 18.7384 15.6597 19.0625 15.3819 19.3403L11.7361 22.9861C11.088 23.6343 10.3472 24.1319 9.51389 24.4792C8.68056 24.8264 7.80093 25 6.875 25ZM8.61111 16.3889C8.33333 16.1111 8.19444 15.7813 8.19444 15.3993C8.19444 15.0174 8.33333 14.6875 8.61111 14.4097L14.4097 8.61111C14.6875 8.33333 15.0174 8.19444 15.3993 8.19444C15.7813 8.19444 16.1111 8.33333 16.3889 8.61111C16.6667 8.88889 16.8056 9.21875 16.8056 9.60069C16.8056 9.98264 16.6667 10.3125 16.3889 10.5903L10.5903 16.3889C10.3125 16.6667 9.98264 16.8056 9.60069 16.8056C9.21875 16.8056 8.88889 16.6667 8.61111 16.3889ZM17.3611 15.3819C17.0833 15.1042 16.9444 14.7801 16.9444 14.4097C16.9444 14.0394 17.0833 13.7153 17.3611 13.4375L21.0417 9.79167C21.4352 9.39815 21.7245 8.95833 21.9097 8.47222C22.0949 7.98611 22.1875 7.47685 22.1875 6.94444C22.1875 5.78704 21.794 4.80324 21.0069 3.99306C20.2199 3.18287 19.2477 2.77778 18.0903 2.77778C17.5579 2.77778 17.0428 2.87616 16.5451 3.07292C16.0475 3.26968 15.6019 3.56482 15.2083 3.95833L11.5625 7.63889C11.2847 7.91667 10.9606 8.05556 10.5903 8.05556C10.2199 8.05556 9.89583 7.91667 9.61806 7.63889C9.34028 7.36111 9.20139 7.03125 9.20139 6.64931C9.20139 6.26736 9.34028 5.9375 9.61806 5.65972L13.2639 2.01389C13.912 1.36574 14.6528 0.868056 15.4861 0.520833C16.3194 0.173611 17.1991 0 18.125 0C20.0231 0 21.6377 0.671296 22.9688 2.01389C24.2998 3.35648 24.9653 4.98843 24.9653 6.90972C24.9653 7.8125 24.7975 8.68056 24.4618 9.51389C24.1262 10.3472 23.6343 11.088 22.9861 11.7361L19.3403 15.3819C19.0625 15.6597 18.7326 15.7986 18.3507 15.7986C17.9688 15.7986 17.6389 15.6597 17.3611 15.3819Z"
      fill={fill}
    />
  </svg>
);
const Email = ({ size, fill }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_1240_249" fill="white">
      <rect x="4.70996" y="9.21289" width="30.4762" height="20.9947" rx="2" />
    </mask>
    <rect
      x="4.70996"
      y="9.21289"
      width="30.4762"
      height="20.9947"
      rx="2"
      stroke="#AF2EFF"
      strokeWidth="4.06349"
      strokeLinejoin="round"
      mask="url(#path-1-inside-1_1240_249)"
    />
    <path
      d="M19.9485 21.4034L6.06494 10.5674L33.2304 10.8919L19.9485 21.4034Z"
      fill="#AF2EFF"
      stroke="#AF2EFF"
      strokeWidth="2.70899"
      strokeLinejoin="round"
    />
    <path
      d="M33.1548 28.1758L25.705 21.4033"
      stroke="#AF2EFF"
      strokeWidth="2.03175"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.74219 28.1758L14.1919 21.4033"
      stroke="#AF2EFF"
      strokeWidth="2.03175"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Phone = ({ size, fill }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_1240_255" fill="white">
      <path d="M28.9047 3C30.0619 3 31 3.93808 31 5.09526L31 34.9047C31 36.0619 30.0619 37 28.9047 37L11.0953 37C9.93808 37 9 36.0619 9 34.9047L9 5.09526C9 3.93808 9.93808 3 11.0953 3L28.9047 3Z" />
    </mask>
    <path
      d="M29.9856 1.95237C31.7214 1.95237 33.1285 3.35949 33.1285 5.09526L33.1285 34.9047C33.1285 36.6405 31.7214 38.0476 29.9856 38.0476L28.8715 35.9524C28.8715 35.9524 28.8715 35.4833 28.8715 34.9047L28.8715 5.09526C28.8715 4.51667 28.8715 4.04763 28.8715 4.04763L29.9856 1.95237ZM10.0144 38.0476C8.2786 38.0476 6.87148 36.6405 6.87148 34.9047L6.87148 5.09526C6.87148 3.35949 8.2786 1.95237 10.0144 1.95237L11.1285 4.04763C11.1285 4.04763 11.1285 4.51667 11.1285 5.09526L11.1285 34.9047C11.1285 35.4833 11.1285 35.9524 11.1285 35.9524L10.0144 38.0476ZM6.87148 5.09526C6.87148 3.35949 8.2786 1.95237 10.0144 1.95237L29.9856 1.95237C31.7214 1.95237 33.1285 3.35949 33.1285 5.09526L28.8715 5.09526C28.8715 4.51667 28.8715 4.04763 28.8715 4.04763L11.1285 4.04763C11.1285 4.04763 11.1285 4.51667 11.1285 5.09526L6.87148 5.09526ZM33.1285 34.9047C33.1285 36.6405 31.7214 38.0476 29.9856 38.0476L10.0144 38.0476C8.2786 38.0476 6.87148 36.6405 6.87148 34.9047L11.1285 34.9047C11.1285 35.4833 11.1285 35.9524 11.1285 35.9524L28.8715 35.9524C28.8715 35.9524 28.8715 35.4833 28.8715 34.9047L33.1285 34.9047Z"
      fill="#AF2EFF"
      mask="url(#path-1-inside-1_1240_255)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.8993 31H11.0896V36.2382H28.8993V31ZM19.9945 35.1907C20.8624 35.1907 21.566 34.4872 21.566 33.6193C21.566 32.7514 20.8624 32.0479 19.9945 32.0479C19.1267 32.0479 18.4231 32.7514 18.4231 33.6193C18.4231 34.4872 19.1267 35.1907 19.9945 35.1907Z"
      fill="#AF2EFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.8993 4H11.0896V8.19053H28.8993V4ZM16.3277 5.04785C15.7491 5.04785 15.28 5.51689 15.28 6.09548C15.28 6.67407 15.7491 7.14311 16.3277 7.14311H23.6611C24.2397 7.14311 24.7087 6.67407 24.7087 6.09548C24.7087 5.51689 24.2397 5.04785 23.6611 5.04785H16.3277Z"
      fill="#AF2EFF"
    />
  </svg>
);
const Figma = ({ size, fill }) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1015 36.7508C13.9008 36.7508 13.1169 36.6549 12.1279 35.9305C10.2856 34.581 9.72989 32.2095 10.709 30.2481C11.4333 28.7861 12.935 27.7508 14.8203 27.7508H19.3915V32.2525C19.3915 34.0386 18.171 35.656 16.881 36.2778C16.4543 36.4829 15.6936 36.7508 15.1015 36.7508ZM15.1246 39H14.3937C13.4973 38.957 12.6142 38.7387 11.8203 38.3451C11.4565 38.1665 11.1059 37.9713 10.8016 37.7464C10.6263 37.6174 10.494 37.5215 10.3385 37.366C8.64168 35.6858 8 34.4719 8 31.8986C8 30.1389 9.13121 28.0816 10.4212 27.0761C10.58 26.9537 10.8578 26.7552 10.9537 26.6262C10.8115 26.4311 9.7762 25.839 8.9526 24.4763C8.16207 23.1665 8 22.237 8 20.6494C8 17.3815 10.7883 15.5987 10.9537 15.3771C10.7685 15.1224 9.79605 14.6196 8.96252 13.2172C8.18523 11.914 8 11.0706 8 9.46968C8 8.46086 8.29107 7.54135 8.63176 6.86659C9.24367 5.65601 9.74974 5.01433 10.8413 4.22381C11.7839 3.54576 13.1566 3 14.4697 3H26.5625C29.9429 3 33.0322 6.08931 33.0322 9.46968V10.1014C33.0322 11.8478 31.9043 13.9151 30.611 14.9239C30.4522 15.0496 30.1744 15.2448 30.0785 15.3771L31.1865 16.376C33.1116 18.2845 33.5945 21.4796 32.3773 23.9305C30.5052 27.6979 25.8778 28.839 22.4974 26.6825C22.1699 26.4708 21.9516 26.2723 21.6407 26.0639C21.6407 27.6814 21.6407 29.2988 21.6407 30.9162C21.6407 32.8776 21.6275 33.7211 20.9858 35.1103C20.5095 36.1422 19.6793 37.075 18.7697 37.7464C17.741 38.5072 16.4444 38.9338 15.1246 39ZM10.2492 21.2811C10.2492 19.7828 10.527 18.86 11.5689 17.8181C12.3198 17.0673 13.3914 16.5017 14.5392 16.5017H19.3915V25.5017H14.5392C12.4124 25.5017 10.2492 23.4675 10.2492 21.2811ZM21.6407 21.0695C21.6407 18.4862 23.7377 16.5017 25.9307 16.5017C26.9428 16.5017 27.2438 16.5215 28.1931 16.9118C28.686 17.1103 29.0796 17.4311 29.4302 17.785C31.0575 19.4223 31.2395 21.8765 29.9594 23.6229C29.5393 24.1985 28.8712 24.7674 28.2394 25.0684C25.2659 26.4774 21.6407 24.4035 21.6407 21.0695ZM26.2118 14.2492H21.6407V5.24917H26.5625C28.719 5.24917 30.783 7.31312 30.783 9.46968C30.783 11.0441 30.4555 11.9405 29.3938 13.0022C28.6959 13.7034 27.5911 14.2492 26.2118 14.2492ZM10.2492 10.032V9.46968C10.2492 7.31312 12.3132 5.24917 14.4697 5.24917H19.3915V14.2492H14.8203C13.4708 14.2492 12.3595 13.7166 11.6715 13.0386C11.0133 12.387 10.2492 11.3087 10.2492 10.032Z"
      fill={fill ? fill : "#fff"}
    />
  </svg>
);
const React = ({ size, fill }) => (
  <svg
    width="43"
    height="42"
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1240_367)">
      <path
        d="M42.1484 21C42.1484 18.15 38.8484 15.75 33.5984 14.25C34.9484 9 34.4984 4.95 32.0984 3.45C31.4984 3.15 30.8984 3 30.1484 3C27.8984 3 24.8984 4.65 21.8984 7.5C18.8984 4.65 16.0484 3 13.6484 3C12.8984 3 12.2984 3.15 11.6984 3.45C9.44844 4.95 8.99844 9 10.1984 14.25C5.09844 15.75 1.64844 18.3 1.64844 21C1.64844 23.85 4.94844 26.25 10.1984 27.75C8.99844 33 9.44844 37.2 11.8484 38.55C12.4484 38.85 13.0484 39 13.7984 39C16.0484 39 19.0484 37.35 22.0484 34.5C25.0484 37.35 27.8984 39 30.2984 39C31.0484 39 31.6484 38.85 32.2484 38.55C34.6484 37.2 35.0984 33 33.8984 27.75C38.8484 26.25 42.1484 23.7 42.1484 21ZM30.1484 4.95C30.5984 4.95 30.8984 4.95 31.0484 5.25C32.2484 5.85 32.6984 8.25 32.2484 11.4C32.0984 12.15 31.9484 13.05 31.7984 13.8C30.1484 13.35 28.4984 13.2 26.5484 12.9C25.4984 11.4 24.4484 10.05 23.2484 8.85C25.9484 6.3 28.4984 4.95 30.1484 4.95ZM27.4484 24.15C26.8484 25.2 26.2484 26.25 25.4984 27.15C24.2984 27.3 23.0984 27.3 21.8984 27.3C20.6984 27.3 19.4984 27.3 18.2984 27.15C17.6984 26.25 17.0984 25.2 16.3484 24.15C15.7484 23.1 15.1484 22.05 14.6984 21C15.1484 19.95 15.7484 18.9 16.3484 17.85C16.9484 16.8 17.6984 15.75 18.2984 14.7C19.4984 14.55 20.6984 14.55 21.8984 14.55C23.0984 14.55 24.2984 14.55 25.4984 14.7C26.0984 15.6 26.8484 16.65 27.4484 17.85C28.0484 18.9 28.6484 19.95 29.0984 21C28.6484 22.05 28.0484 23.1 27.4484 24.15ZM30.1484 23.25C30.5984 24.3 30.8984 25.35 31.1984 26.25C30.1484 26.55 29.0984 26.7 28.0484 26.85C28.3484 26.25 28.7984 25.65 29.0984 25.05C29.5484 24.6 29.8484 23.85 30.1484 23.25ZM21.8984 31.8C21.1484 31.05 20.3984 30.15 19.7984 29.25C20.5484 29.25 21.2984 29.25 21.8984 29.25C22.6484 29.25 23.3984 29.25 23.9984 29.25C23.3984 30.15 22.6484 31.05 21.8984 31.8ZM15.7484 27C14.6984 26.85 13.6484 26.7 12.5984 26.4C12.8984 25.35 13.3484 24.3 13.6484 23.4C13.9484 24 14.2484 24.6 14.6984 25.2C15.1484 25.8 15.4484 26.4 15.7484 27ZM13.6484 18.75C13.1984 17.7 12.8984 16.65 12.4484 15.6C13.4984 15.3 14.5484 15.15 15.7484 15C15.2984 15.6 14.9984 16.2 14.5484 16.8C14.3984 17.55 14.0984 18.15 13.6484 18.75ZM21.8984 10.2C22.6484 10.95 23.2484 11.85 23.9984 12.6C23.2484 12.6 22.6484 12.6 21.8984 12.6C21.1484 12.6 20.5484 12.6 19.7984 12.6C20.5484 11.85 21.2984 10.95 21.8984 10.2ZM29.0984 16.8C28.6484 16.2 28.3484 15.6 27.8984 15C29.0984 15.15 30.1484 15.3 31.1984 15.6C30.8984 16.65 30.4484 17.7 29.9984 18.75C29.8484 18.15 29.5484 17.55 29.0984 16.8ZM11.6984 11.25C11.2484 8.1 11.6984 5.85 12.8984 5.1C13.1984 4.95 13.4984 4.8 13.7984 4.8C15.4484 4.8 17.8484 6.15 20.5484 8.7C19.4984 9.9 18.2984 11.25 17.2484 12.75C15.4484 12.9 13.6484 13.2 11.9984 13.65C11.8484 12.9 11.6984 12 11.6984 11.25ZM8.39844 25.05C5.54844 23.85 3.59844 22.2 3.59844 21C3.59844 19.65 5.39844 18.15 8.24844 16.95C8.99844 16.65 9.74844 16.35 10.6484 16.2C11.0984 17.85 11.6984 19.5 12.5984 21.15C11.8484 22.8 11.2484 24.45 10.7984 25.95C9.89844 25.65 9.14844 25.35 8.39844 25.05ZM12.7484 36.9C11.5484 36.3 11.0984 33.9 11.5484 30.75C11.6984 30 11.8484 29.1 11.9984 28.2C13.6484 28.5 15.2984 28.8 17.0984 28.95C18.1484 30.45 19.3484 31.8 20.3984 33C17.6984 35.55 15.2984 36.9 13.6484 36.9C13.3484 37.05 13.0484 36.9 12.7484 36.9ZM32.2484 30.75C32.6984 33.9 32.2484 36.15 31.0484 36.9C30.7484 37.05 30.4484 37.2 30.1484 37.2C28.4984 37.2 26.0984 35.85 23.3984 33.3C24.5984 32.1 25.6484 30.75 26.6984 29.25C28.4984 29.1 30.2984 28.8 31.7984 28.5C31.9484 29.1 32.0984 29.85 32.2484 30.75ZM35.5484 25.05C34.7984 25.35 34.0484 25.65 33.1484 25.8C32.6984 24.3 32.0984 22.65 31.3484 21C32.0984 19.35 32.6984 17.7 33.2984 16.05C34.0484 16.35 34.9484 16.5 35.6984 16.8C38.5484 18 40.3484 19.5 40.3484 20.85C40.1984 22.2 38.3984 23.85 35.5484 25.05Z"
        fill={fill ? fill : "#fff"}
      />
      <path
        d="M22.0483 24.75C24.1483 24.75 25.7983 23.1 25.7983 21C25.7983 18.9 24.1483 17.25 22.0483 17.25C19.9483 17.25 18.2983 18.9 18.2983 21C18.2983 23.1 19.9483 24.75 22.0483 24.75Z"
        fill={fill ? fill : "#fff"}
      />
    </g>
    <defs>
      <clipPath id="clip0_1240_367">
        <rect
          width="42"
          height="42"
          fill={fill ? fill : "#fff"}
          transform="translate(0.648438)"
        />
      </clipPath>
    </defs>
  </svg>
);
const Angular = ({ size, fill }) => (
  <svg
    width="43"
    height="42"
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2972 4.2L21.6268 3.04617C21.4113 2.98461 21.183 2.98461 20.9675 3.04617L21.2972 4.2ZM4.49718 9L4.16752 7.84618C3.60457 8.00702 3.23987 8.55062 3.30452 9.13253L4.49718 9ZM6.89718 30.6L5.70452 30.7325C5.74948 31.1371 5.99644 31.4914 6.36051 31.6733L6.89718 30.6ZM21.2972 37.8L20.7605 38.8733C21.0983 39.0422 21.496 39.0422 21.8338 38.8733L21.2972 37.8ZM35.6971 30.6L36.2338 31.6733C36.5979 31.4914 36.8448 31.1371 36.8897 30.7325L35.6971 30.6ZM38.0971 9L39.2897 9.13253C39.3545 8.55062 38.9897 8.00702 38.4269 7.84618L38.0971 9ZM21.2972 10.2L22.3965 9.71902L21.2972 7.20612L20.1978 9.71902L21.2972 10.2ZM20.9675 3.04617L4.16752 7.84618L4.82685 10.1538L21.6268 5.35383L20.9675 3.04617ZM3.30452 9.13253L5.70452 30.7325L8.08983 30.4675L5.68984 8.86747L3.30452 9.13253ZM6.36051 31.6733L20.7605 38.8733L21.8338 36.7267L7.43384 29.5267L6.36051 31.6733ZM21.8338 38.8733L36.2338 31.6733L35.1605 29.5267L20.7605 36.7267L21.8338 38.8733ZM36.8897 30.7325L39.2897 9.13253L36.9046 8.86747L34.5046 30.4675L36.8897 30.7325ZM38.4269 7.84618L21.6268 3.04617L20.9675 5.35383L37.7674 10.1538L38.4269 7.84618ZM13.9966 29.881L22.3965 10.681L20.1978 9.71902L11.7978 28.919L13.9966 29.881ZM20.1978 10.681L28.5977 29.881L30.7966 28.919L22.3965 9.71902L20.1978 10.681ZM15.2972 24.6H27.2971V22.2H15.2972V24.6Z"
      fill={fill ? fill : "#fff"}
    />
  </svg>
);
const CircularContact = ({ size, fill }) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_2588_818" fill="white">
      <rect x="7.06494" y="13.819" width="45.7143" height="31.4921" rx="3" />
    </mask>
    <rect
      x="7.06494"
      y="13.819"
      width="45.7143"
      height="31.4921"
      rx="3"
      stroke="#17082F"
      strokeWidth="6.09524"
      strokeLinejoin="round"
      mask="url(#path-1-inside-1_2588_818)"
    />
    <path
      d="M29.9231 32.1049L9.09766 15.851L49.8459 16.3377L29.9231 32.1049Z"
      fill="#17082F"
      stroke="#17082F"
      strokeWidth="4.06349"
      strokeLinejoin="round"
    />
    <path
      d="M49.7324 42.2637L38.5578 32.1049"
      stroke="#17082F"
      strokeWidth="3.04762"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1133 42.2635L21.2879 32.1047"
      stroke="#17082F"
      strokeWidth="3.04762"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const CloseButton = ({ setOpen }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => setOpen(false)}
    >
      <rect
        x="-0.735361"
        width="30.159"
        height="1.03997"
        rx="0.519983"
        transform="matrix(-0.707101 -0.707112 -0.707101 0.707112 23.1802 22.4468)"
        fill="#17082F"
        stroke="#17082F"
        strokeWidth="0.7"
      />
      <rect
        x="0.735361"
        width="30.159"
        height="1.03997"
        rx="0.519983"
        transform="matrix(0.707101 -0.707112 0.707101 0.707112 1.12164 23.4868)"
        fill="#17082F"
        stroke="#17082F"
        strokeWidth="0.7"
      />
    </svg>
  );
};

const WorkStageIcon = () => {
  return (
    <svg
      width="108"
      height="76"
      viewBox="0 0 108 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83594 0.4375C2.17908 0.4375 0.835938 1.78064 0.835938 3.4375V55.1298C0.835938 56.7867 2.17908 58.1298 3.83593 58.1298H24.1216V75.4378L35.3401 58.1298H104.209C105.866 58.1298 107.209 56.7867 107.209 55.1298V3.4375C107.209 1.78065 105.866 0.4375 104.209 0.4375H3.83594Z"
        fill="#AF2EFF"
      />
      <ellipse
        cx="40.738"
        cy="29.2837"
        rx="3.32394"
        ry="3.84616"
        fill="white"
      />
      <ellipse
        cx="54.0349"
        cy="29.2837"
        rx="3.32394"
        ry="3.84616"
        fill="white"
      />
      <ellipse
        cx="67.3239"
        cy="29.2837"
        rx="3.32394"
        ry="3.84616"
        fill="white"
      />
    </svg>
  );
};

const CheckDevelopmentStageIcon = () => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0052 30.0905C23.369 30.0905 29.3385 24.121 29.3385 16.7572C29.3385 9.39336 23.369 3.42383 16.0052 3.42383C8.64141 3.42383 2.67188 9.39336 2.67188 16.7572C2.67188 24.121 8.64141 30.0905 16.0052 30.0905Z"
        fill="#AF2EFF"
      />
      <path
        d="M14.6669 22.0907C14.4914 22.0918 14.3175 22.0581 14.155 21.9918C13.9926 21.9254 13.8448 21.8277 13.7202 21.7041L9.72025 17.7041C9.59593 17.5798 9.49732 17.4322 9.43003 17.2697C9.36275 17.1073 9.32812 16.9332 9.32812 16.7574C9.32812 16.4023 9.46918 16.0618 9.72025 15.8107C9.97132 15.5597 10.3118 15.4186 10.6669 15.4186C11.022 15.4186 11.3625 15.5597 11.6136 15.8107L14.6669 18.8774L20.3869 13.1441C20.638 12.893 20.9785 12.752 21.3336 12.752C21.6886 12.752 22.0292 12.893 22.2802 13.1441C22.5313 13.3951 22.6724 13.7357 22.6724 14.0907C22.6724 14.4458 22.5313 14.7863 22.2802 15.0374L15.6136 21.7041C15.489 21.8277 15.3412 21.9254 15.1788 21.9918C15.0163 22.0581 14.8424 22.0918 14.6669 22.0907Z"
        fill="white"
      />
    </svg>
  );
};

export const Icons = {
  Arrow,
  Facebook,
  LinkedIn,
  Clutch,
  Instagram,
  WhatsApp,
  X,
  LinkIcon,
  Phone,
  Email,
  Figma,
  React,
  Angular,
  CircularContact,
  CloseButton,
  WorkStageIcon,
  CheckDevelopmentStageIcon,
};
